interface Waiting {
  kind: 'waiting';
}

interface Copying {
  kind: 'copying';
}

interface Copied {
  kind: 'copied';
}

export const waiting = (): Waiting => ({ kind: 'waiting' });

export const copying = (): Copying => ({ kind: 'copying' });

export const copied = (): Copied => ({ kind: 'copied' });

export type State = Waiting | Copying | Copied;
